import { render, staticRenderFns } from "./MessageType.vue?vue&type=template&id=e4afb704&scoped=true"
import script from "./MessageType.vue?vue&type=script&lang=js"
export * from "./MessageType.vue?vue&type=script&lang=js"
import style0 from "./MessageType.vue?vue&type=style&index=0&id=e4afb704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4afb704",
  null
  
)

export default component.exports